"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var spotReportPath = function spotReportPath(slug, id) {
  return "/surf-report/" + slug + "/" + id;
};
var spotForecastPath = function spotForecastPath(slug, id) {
  return "/surf-report/" + slug + "/" + id + "/forecast";
};

var subregionForecastPath = function subregionForecastPath(slug, id) {
  return "/surf-forecasts/" + slug + "/" + id;
};
var subregionForecastChartsPath = function subregionForecastChartsPath(slug, id) {
  return "/surf-forecasts/" + slug + "/" + id + "/charts";
};
var subregionPremiumAnalysisPath = function subregionPremiumAnalysisPath(slug, id) {
  return "/surf-forecasts/" + slug + "/" + id + "/premium-analysis";
};

var mapPath = function mapPath(_ref, zoom) {
  var lat = _ref.lat,
      lon = _ref.lon;
  return "surf-reports-forecasts-cams-map/@" + lat + "," + lon + "," + zoom + "z";
};
var geonameMapPath = function geonameMapPath(slug, geonameId) {
  return "surf-reports-forecasts-cams/" + slug + "/" + geonameId;
};

exports.spotReportPath = spotReportPath;
exports.spotForecastPath = spotForecastPath;
exports.subregionForecastPath = subregionForecastPath;
exports.subregionForecastChartsPath = subregionForecastChartsPath;
exports.subregionPremiumAnalysisPath = subregionPremiumAnalysisPath;
exports.mapPath = mapPath;
exports.geonameMapPath = geonameMapPath;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/paths/kbyg.js
// module id = 407
// module chunks = 11